export const isVerifiedExtensionEvent = (event: CustomEventInit): boolean =>
  event.detail?.direction === 'from-content-script' &&
  event.detail?.source === 'extension';
